import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBan } from "@fortawesome/pro-duotone-svg-icons"
import PropTypes from 'prop-types'
import BaseButton from './BaseButton'


export default function ButtonCancel({
  className,
  disabled,
  loading,
  onClick,
  size,
  title,
}) {

  return (
    <BaseButton
      className={"cancel-button" + (className ? " " + className :  "")}
      icon={
        <FontAwesomeIcon className="w-100 h-100" icon={faBan} />
      }
      type="text"
      size={size}
      title={title || "Cancel"}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    />
  )
}

ButtonCancel.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf([
    'large',
    'middle',
    'small'
  ]),
  loading: PropTypes.bool,
  onClick: PropTypes.func,
}
